import http from "plugins/axios";

export default {
  //更新后的查询所有用户信息
  getUserList(data) {
    return http.get({
      url: `/la/admin/channel/trade/getUserTradePage`,
      data
    });
  },
  // 添加备注
  addRemark({ channelId, userId, remarks }) {
    return http.post({
      url: `/channel/user/addRemark?channelId=${channelId}&remarks=${remarks}&userId=${userId}`,
    });
  },

  //成交汇总
  getDetail(data) {
    return http.get({
      url: `/la/admin/channel/trade/getTotalInfo`, data
    });
  },
  //获取币种列表
  getCoinList() {
    return http.get({
      url: "/channel/common/coinList",
    });
  },
  //返佣统计记录
  getDetailRecord({ time, channelId }) {
    return http.get({
      url: `/channel/rebate/info?channelId=${channelId}&time=${time}`,
    });
  },
};
